import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { catchError, debounceTime, filter, map, Observable, of, switchMap } from 'rxjs';
import { GooglePlacesService } from 'src/app/_core/api/google-places.service';
import { GooglePlaceAddress } from 'src/app/_core/models/Address';

@Component({
  selector: 'app-places-autocomplete',
  templateUrl: './places-autocomplete.component.html',
  styleUrls: ['./places-autocomplete.component.scss'],
})
export class PlacesAutocompleteComponent implements OnInit {
  @Input() clearInputValue: boolean = true;
  @Output() selectedGooglePlaceEmitter = new EventEmitter<GooglePlaceAddress>();
  groupForm: UntypedFormGroup;
  searchResultsPlaces: Observable<any[]>;

  constructor(private googlePlacesService: GooglePlacesService, private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.groupForm = this.formBuilder.group({
      searchPlaces: [],
    });

    this.placesLiveSearch();
  }

  placesLiveSearch(): void {
    this.searchResultsPlaces = this.searchPlaces.valueChanges.pipe(
      filter((value) => typeof value === 'string' && value.trim().length > 0),
      debounceTime(200),
      switchMap((value: string) =>
        this.googlePlacesService.getAutocompleteSuggestions({ input: value, languageCode: 'en' }).pipe(catchError((err) => of(err)))
      ),
      map((value) => value.suggestions || [])
    );
  }

  selectedPlace(event: MatAutocompleteSelectedEvent, inputGooglePlacesRef: HTMLInputElement) {
    if (this.clearInputValue) {
      inputGooglePlacesRef.value = '';
    }
    this.googlePlacesService.getPlaceDetails(event.option.value.placePrediction.placeId).subscribe((response: GooglePlaceAddress) => {
      this.selectedGooglePlaceEmitter.emit(response);
    });
  }

  get searchPlaces(): AbstractControl {
    return this.groupForm.get('searchPlaces') as AbstractControl;
  }
}
